import * as React from 'react';

interface PreventableEvent {
  preventDefault: () => void;
}

export function useBusyDialogGuard(isBusy: boolean, onClose: () => void) {
  const close = React.useCallback(() => {
    if (!isBusy) onClose();
  }, [isBusy, onClose]);
  const onOpenChange = React.useCallback(
    (open: boolean) => {
      if (!open) close();
    },
    [close],
  );
  const onDismissInteraction = React.useCallback(
    (event: PreventableEvent) => {
      if (isBusy) event.preventDefault();
    },
    [isBusy],
  );

  return { close, onOpenChange, onDismissInteraction };
}
